import { gql } from "graphql-request";

export const CREATE_GROUP_MUTATION = gql`
  mutation InsertGroup(
    $name: String!
    $description: String
    $coverImageUrl: String
    $isPrivate: Boolean
    $organizationIds: [String]
  ) {
    insertgroup(
      input: {
        OrganizationIds: $organizationIds
        name: $name
        description: $description
        coverImageUrl: $coverImageUrl
        isPrivate: $isPrivate
      }
    ) {
      acknowledged
      totalImpactedData
      itemId
    }
  }
`;

export const CREATE_GROUP_MEMBERSHIP_MUTATION = gql`
  mutation InsertGroupMembership(
    $groupId: String!
    $userId: String!
    $role: String!
    $status: String!
    $joinType: String!
    $joinedAt: String!
    $invitedBy: String
    $groupUserSnapshot: usersnapshotInput!
    $organizationIds: [String]
  ) {
    insertgroupmembership(
      input: {
        OrganizationIds: $organizationIds
        groupId: $groupId
        userId: $userId
        role: $role
        status: $status
        joinType: $joinType
        invitedBy: $invitedBy
        groupUserSnapshot: $groupUserSnapshot
        joinedAt: $joinedAt
      }
    ) {
      acknowledged
      totalImpactedData
      itemId
    }
  }
`;

export const UPDATE_GROUP_MEMBERSHIP_MUTATION = gql`
  mutation UpdateGroupMembership(
    $filter: String!
    $status: String
    $role: String
  ) {
    updategroupmembership(
      filter: $filter
      input: { status: $status, role: $role }
    ) {
      acknowledged
      totalImpactedData
      itemId
    }
  }
`;

export const UPDATE_SEASON_MUTATION = gql`
  mutation UpdateSeason($ItemId: ID!, $status: String, $endDate: DateTime) {
    updateseason(
      filter: { ItemId: { eq: $ItemId } }
      input: { status: $status, endDate: $endDate }
    ) {
      acknowledged
      totalImpactedData
      itemId
    }
  }
`;

export const DELETE_GROUP_MEMBERSHIP_MUTATION = gql`
  mutation DeleteGroupMembership($filter: String!) {
    deletegroupmembership(filter: $filter, input: { isHardDelete: true }) {
      acknowledged
      totalImpactedData
      itemId
    }
  }
`;

export const DELETE_GROUP_MUTATION = gql`
  mutation DeleteGroup($filter: String!) {
    deletegroup(filter: $filter, input: { isHardDelete: true }) {
      acknowledged
      totalImpactedData
      itemId
    }
  }
`;

// Bulk delete: every membership belonging to a user (used by the user-deletion purge).
export const DELETE_MANY_GROUP_MEMBERSHIP_BY_USER = gql`
  mutation DeleteManyGroupMembershipByUser($userId: String!) {
    deleteManygroupmembership(
      where: { userId: { eq: $userId } }
      input: { isHardDelete: true }
    ) {
      acknowledged
      totalImpactedData
      itemId
      message
    }
  }
`;

// Bulk delete: every membership of a group (used when deleting a group).
export const DELETE_MANY_GROUP_MEMBERSHIP_BY_GROUP = gql`
  mutation DeleteManyGroupMembershipByGroup($groupId: String!) {
    deleteManygroupmembership(
      where: { groupId: { eq: $groupId } }
      input: { isHardDelete: true }
    ) {
      acknowledged
      totalImpactedData
      itemId
      message
    }
  }
`;

// Bulk delete: every group created by a user (used by the user-deletion purge).
export const DELETE_MANY_GROUP_BY_CREATOR = gql`
  mutation DeleteManyGroupByCreator($createdBy: String!) {
    deleteManygroup(
      where: { CreatedBy: { eq: $createdBy } }
      input: { isHardDelete: true }
    ) {
      acknowledged
      totalImpactedData
      itemId
      message
    }
  }
`;

export const GET_GROUPS_QUERY = gql`
  query GetGroups(
    $filter: String
    $sort: String
    $pageNo: Int
    $pageSize: Int
  ) {
    getgroups(
      input: {
        filter: $filter
        sort: $sort
        pageNo: $pageNo
        pageSize: $pageSize
      }
    ) {
      totalCount
      totalPages
      hasNextPage
      hasPreviousPage
      items {
        ItemId
        name
        coverImageUrl
        memberCount
        isPrivate
        description
        CreatedBy
        CreatedDate
      }
    }
  }
`;

export const GET_GROUP_MEMBERS_QUERY = gql`
  query GetGroupMembers(
    $filter: String
    $sort: String
    $pageNo: Int
    $pageSize: Int
  ) {
    getgroupmemberships(
      input: {
        filter: $filter
        sort: $sort
        pageNo: $pageNo
        pageSize: $pageSize
      }
    ) {
      items {
        ItemId
        groupId
        userId
        role
        status
        joinType
        joinedAt
        groupUserSnapshot {
          firstName
          lastName
          email
          profileImageUrl
        }
      }
      totalCount
      totalPages
      hasNextPage
      hasPreviousPage
    }
  }
`;

export const UPDATE_GROUP_MUTATION = gql`
  mutation UpdateGroup(
    $name: String
    $description: String
    $coverImageUrl: String
    $filter: String
    $isPrivate: Boolean
  ) {
    updategroup(
      filter: $filter
      input: {
        name: $name
        description: $description
        coverImageUrl: $coverImageUrl
        isPrivate: $isPrivate
      }
    ) {
      acknowledged
      totalImpactedData
      itemId
    }
  }
`;

export const GET_GROUP_MEMBER_COUNT = gql`
  query GetGroupMemberCount($filter: String) {
    getgroupmemberships(input: { filter: $filter }) {
      totalCount
    }
  }
`;
